import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";
import InterviewNewsfeedItemBody from "./interview_newsfeed_item_body";

export default GrComponentFactory.createClass({
  displayName: "InterviewNewsfeedItem",

  propTypes: {
    resource: GrPropTypes.interviewNewsfeedResource(),
  },

  renderCard() {
    return (
      <div>
        <InterviewNewsfeedItemBody resource={this.props.resource} />
      </div>
    );
  },

  render() {
    return <SocialUpdate
      body={this.renderCard()}
      {...this.props}
    />;
  },
});
